import styled from 'styled-components';
import * as palette from '../../styles/variables';

export const Container = styled.div`
  width: 100%;
  height: ${props => (props && props.folder ? '150px' : '100%')} ;
  display: flex;
  align-items: center;
  justify-content: center;
  .anticon {
    font-size: 72px;
    color: ${palette.PRIMARY_COLOR};
    background: ${props => (props && props.fullpage ? '#fff' : '')};
    padding: ${props => (props && props.fullpage ? '50px' : '')};
    border-radius: ${props => (props && props.fullpage ? '4px' : '')};
  }
  .loaderContainer {
    background: #fff;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 1rem 2rem;
    gap: .5rem;

    .loaderText {
      color: black;
    }
    .spinner {
      width: 70px;
      text-align: center;
    }

    .spinner > div {
      width: 18px;
      height: 18px;
      background-color: #333;

      border-radius: 100%;
      display: inline-block;
      -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
      animation: sk-bouncedelay 1.4s infinite ease-in-out both;
    }

    .spinner .bounce1 {
      -webkit-animation-delay: -0.32s;
      animation-delay: -0.32s;
    }

    .spinner .bounce2 {
      -webkit-animation-delay: -0.16s;
      animation-delay: -0.16s;
    }

    @-webkit-keyframes sk-bouncedelay {
      0%,
      80%,
      100% {
        -webkit-transform: scale(0);
      }
      40% {
        -webkit-transform: scale(1);
      }
    }

    @keyframes sk-bouncedelay {
      0%,
      80%,
      100% {
        -webkit-transform: scale(0);
        transform: scale(0);
      }
      40% {
        -webkit-transform: scale(1);
        transform: scale(1);
      }
    }
  }
`;
